import { Document, Page } from '@react-pdf/renderer';
import './style.css';
import { observer } from 'mobx-react-lite';
import Html from 'react-pdf-html';
import ReactDOMServer from 'react-dom/server';
import { metadataType } from '../../../app/api/types';
import { useEffect } from 'react';
import { useStore } from '../../../app/stores/store';
import {
  aSummaryResto,
  label,
  pictureVendor,
  supervisorIndicesResto,
} from './constant';
import { CheckboxHandler, dateConvertHandler } from './ColorGrading';
import { getImageSrc } from '../../../utils/ImageHelper';

const NFAIRestorationReport = ({isDualPDF}:{isDualPDF:boolean}) => {
  const {
    viewStore: { metadata, parentMetadata },
    activityStore: { selectedActivity },
    masteringStore
  } = useStore();

  useEffect(() => {
    if (selectedActivity?.id) {
      parentMetadata({ itemId: selectedActivity?.id });
    }
    // eslint-disable-next-line
  }, []);

  const getColumn = (data: any, num: number) => {
    let halfLength = 0;
    halfLength = Math.ceil(data?.length / 2);
    const column1 = data?.slice(0, halfLength);
    const column2 = data?.slice(halfLength);
    if (num === 1) {
      return column1;
    } else {
      return column2;
    }
  };

  const element = (
    <html>
      <body>
        <style>
          {`
          * {
            font-size: 8px;
          }
          #container {
            margin: 10px;
          }
        #container tbody {
          column-count:2;
    -moz-column-count:2;
    -webkit-column-count:2;
        }
        .l-grey-bg {
          background-color: lightgray;
        }
        .grey-bg {
          background-color: gray;
        }
        .d-grey-bg {
          background-color: darkslategray;
        }
        .nfai-table {
          width: 90%;
          margin-left: auto;
          margin-right: auto;
        }
        .center-content {
          text-align: center;
        }
        .padding-3 {
          padding: 3px;
        }
        .padding-1 {
          padding: 1px;
        }
        .nfai-table,
        .nfai-table th,
        .nfai-table td {
          border: 1px solid black;
          border-collapse: collapse;
        }
        .nfai-table td {
          padding: 1px;
        }
        .nfai-table table,
        .nfai-table table th, .nfai-table table td {
          border: none;
          border-collapse: collapse;
        }
        .bold {
          font-weight: 700;
        }
        .border-top-0 {
          border-top: 0px;
        }
        .border-bottom-0 {
          border-bottom: 0px;
        }
        .white-text {
          color: white;
        }
        .yellow-bg {
          background-color: #cb9d06;
        }
         .center-left {
          text-align: left;
        }
        .center-right {
          text-align: right;
        }
        `}
        </style>
        <div id="container">
          <table className="nfai-table">
            <thead>
              <tr>
                <th className="center-content padding-3 bold">
                  <strong>RESTORATION REPORT</strong>
                </th>
              </tr>
              <tr>
                <th className="l-grey-bg center-content padding-1 bold">
                  NFHM Restoration Project
                </th>
              </tr>
              <tr>
                <th className="grey-bg center-content padding-1 bold white-text">
                  PICTURE VENDOR NAME: Prasad Corporation Private Limited,
                  Chennai
                </th>
              </tr>
            </thead>
            <tbody>
              
              {getColumn(masteringStore.RestorationData.localMetaData[0], 1)?.map(
                (l: metadataType, index: number) => {
                  return (
                    <tr key={l.elementIndex}>
                      <td>
                        {label[l.elementName as keyof typeof label] !==
                        undefined
                          ? label[l.elementName as keyof typeof label].replace('Title Name','Title')
                          : l.elementName}
                        :
                      </td>
                      <td className="center-content center-left">
                        {l.options.length !== 0
                          ? CheckboxHandler(l.options, l.elementValue,'left','RestorationReport')
                          : l.elementValue}
                      </td>
                      <td className='center-right'>
                        {label[
                          getColumn(masteringStore.RestorationData.localMetaData[0], 2)?.[index]
                            ?.elementName as keyof typeof label
                        ] !== undefined
                          ? label[
                              getColumn(masteringStore.RestorationData.localMetaData[0], 2)?.[index]
                                ?.elementName as keyof typeof label
                            ]
                          : getColumn(masteringStore.RestorationData.localMetaData[0], 2)?.[index]
                              ?.elementName}
                        :
                      </td>
                      <td className="center-content center-left">
                        {getColumn(masteringStore.RestorationData.localMetaData[0], 2)?.[index].options
                          .length !== 0
                          ? CheckboxHandler(
                              getColumn(masteringStore.RestorationData.localMetaData[0], 2)?.[index].options,
                              getColumn(masteringStore.RestorationData.localMetaData[0], 2)?.[index]
                                ?.elementValue
                                ,'left','RestorationReport'
                            )
                          : getColumn(masteringStore.RestorationData.localMetaData[0], 2)?.[index]
                          ?.elementType === 'DatePicker' ?
                          dateConvertHandler(getColumn(masteringStore.RestorationData.localMetaData[0], 2)?.[index]
                              ?.elementValue,'typeFirst') : 
                           getColumn(masteringStore.RestorationData.localMetaData[0], 2)?.[index]
                              ?.elementValue}
                      </td>
                    </tr>
                  );
                },
              )}
            </tbody>
          </table>
          <table className="nfai-table border-top-0">
            <thead className="border-top-0">
              <tr>
                <th className="center-content padding-1 bold grey-bg border-top-0 white-text">
                  Summary
                </th>
              </tr>
            </thead>
            <tbody>
              {getColumn(masteringStore.RestorationData.localMetaData[1], 1)?.map(
                (l: metadataType, ind: number) => {
                  return (
                    <tr key={l.elementIndex}>
                      <td>
                        {label[l.elementName as keyof typeof label] !==
                        undefined
                          ? label[l.elementName as keyof typeof label]
                          : l.elementName}
                      </td>
                      <td className="center-content center-left">
                        {l.options.length !== 0
                          ? CheckboxHandler(l.options, l.elementValue,'left','RestorationReport')
                          :  ['Input Format/Medium', 'Delivery Format/Medium'].includes(l?.elementName) && !l.elementValue.includes('dpx') ? `${l?.elementValue} | dpx |` 
                          :  l.elementName === 'Asset ID'  ? <div style={{ display: 'flex', flexDirection: 'row', marginLeft: l.elementName === 'Asset ID' ? '0px' : '-2px' }}> 
                          {l.elementValue?.split('|').length === 1 ? l.elementValue : (l.elementValue?.split('|').map((value, index) => (
                                  <div key={index} style={{ display: 'flex', flexDirection:'row' }}>
                                    <img
                                      src='../assets/NFAI_Restoration_Checkbox_Checked.png'
                                      alt={`Checkbox for ${value}`}
                                      style={{ width: '10px', height: '10px', marginRight: '1px' }}
                                    />
                                    <span>{value}</span>
                                  </div>
                                )))}</div> 
                          : l.elementValue}
                      </td>
                      <td className='center-right'>
                        {label[
                          getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]
                            ?.elementName as keyof typeof label
                        ] !== undefined &&  getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]
                          ?.elementName !== 'Bit Depth' ? label[
                            getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]
                              ?.elementName as keyof typeof label
                          ]                             
                          : getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]?.elementName}
                      </td>
                      <td className="center-content center-left">
                        {getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]?.elementName === 'Bit Depth' ?  <div style={{ display: 'flex', flexDirection: 'row',}}> 
                          {getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]?.elementValue?.split('|').length === 1 ?
                           `${getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]?.elementValue} Bit` : 
                            (getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]?.elementValue?.split('|').map((value:any, index:number) => (
                                  <div key={index} style={{ display: 'flex', flexDirection:'row', margin: '0 1px' }}>
                                    <img
                                      src='../assets/NFAI_Restoration_Checkbox_Checked.png'
                                      alt={`Checkbox for ${value}`}
                                      style={{ width: '10px', height: '10px', marginRight: '1px' }}
                                    />
                                    <span>{value} Bit</span>
                                  </div>
                                )))}</div> :
                          ['Delivery Format/Medium'].includes(getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]
                          ?.elementName) && !getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]
                          ?.elementValue.includes('dpx') ? `${getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]?.elementValue} | dpx |` :
                        getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]?.options
                          ?.length !== 0
                          ? CheckboxHandler(
                              getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]?.options,
                              getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]
                                ?.elementValue,
                              'left',
                                'RestorationReport'
                            )
                          : getColumn(masteringStore.RestorationData.localMetaData[1], 2)?.[ind]?.elementValue}
                      </td>
                    </tr>
                  );
                },
              )}
            </tbody>
          </table>
          {masteringStore.RestorationData.dynDataImageResto['headers']?.length > 0 && (
            <table className="nfai-table border-top-0">
              <thead className="border-top-0">
                <tr className="border-top-0">
                  {masteringStore.RestorationData.dynDataImageResto['headers']?.map((headerName: string) => {
                    return (
                      <th
                        className="center-content padding-1 bold grey-bg white-text border-top-0"
                        key={headerName}
                      >
                        {headerName}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {masteringStore.RestorationData.dynDataImageResto['body']?.map((bodyData: any) => {
                  return (
                    <tr>
                      {masteringStore.RestorationData.dynDataImageResto['headers']?.map(
                        (headerName: string) => {
                          return (
                            <td
                              className={
                                headerName === 'Defects' || headerName === 'Image restoration details' ? 'center-left' : 'center-content'
                              }
                            >
                              {typeof bodyData[headerName] === 'object'
                                ? JSON.stringify(bodyData[headerName])
                                 : headerName === 'Time-code' ? 
                                bodyData[headerName].replaceAll('-',' - ')
                                : bodyData[headerName]}
                            </td>
                          );
                        },
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}

          {masteringStore.RestorationData.dynDataSupervisor['headers']?.length > 0 && (
            <table className="nfai-table border-top-0">
              <thead className="border-top-0">
                <tr>
                  <th className="center-content padding-1 bold grey-bg border-top-0 white-text">
                    NFHM QC Supervisor feedback
                  </th>
                </tr>
                <tr>
                  {masteringStore.RestorationData.dynDataSupervisor['headers']?.map((headerName: string) => {
                    return (
                      <th
                        className="center-content padding-1 bold l-grey-bg"
                        key={headerName}
                      >
                        {headerName}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {masteringStore.RestorationData.dynDataSupervisor['body']?.map((bodyData: any) => {
                  return (
                    <tr>
                      {masteringStore.RestorationData.emptyTable && <br/>}
                      {masteringStore.RestorationData.dynDataSupervisor['headers']?.map(
                        (headerName: string) => {
                          return (
                            <td
                              className={
                                headerName === 'Defects' ? '' : 'center-content'
                              }
                            >
                              {typeof bodyData[headerName] === 'object'
                                ? JSON.stringify(bodyData[headerName])
                                : headerName === 'Time-code' ? 
                                bodyData[headerName].replaceAll('-',' - ')
                                : bodyData[headerName]}
                            </td>
                          );
                        },
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          <table className="nfai-table border-top-0">
            <tr>
              <br />
              <br />
              <br />
              <td className="border-top-0">
              <br /> <br /> <br /> <br /><br /><br />
                {label[
                  masteringStore.RestorationData.supervisorDetails?.[0]?.elementName as keyof typeof label
                ] !== undefined
                  ? label[
                      masteringStore.RestorationData.supervisorDetails?.[0]?.elementName as keyof typeof label
                    ]
                  : masteringStore.RestorationData.supervisorDetails?.[0]?.elementName}
                :{masteringStore.RestorationData.supervisorDetails?.[0]?.elementValue}
              </td>
              <td className="border-top-0">
              <br /> <br /> <br /> <br /><br /><br />
                {label[
                  masteringStore.RestorationData.supervisorDetails?.[1]?.elementName as keyof typeof label
                ] !== undefined
                  ? label[
                      masteringStore.RestorationData.supervisorDetails?.[1]?.elementName as keyof typeof label
                    ]
                  : masteringStore.RestorationData.supervisorDetails?.[1]?.elementName}
                :{dateConvertHandler(masteringStore.RestorationData.supervisorDetails?.[1]?.elementValue)}
              </td>
            </tr>
            </table>
       
            <table className="nfai-table border-top-0">  
            <tr>
              <br />
              <br />
              <br />
              <td  className='border-top-0'>
              <br /> <br /> <br /> <br /><br /><br />
                {label[
                  masteringStore.RestorationData.supervisorDetails?.[2]?.elementName as keyof typeof label
                ] !== undefined
                  ? label[
                      masteringStore.RestorationData.supervisorDetails?.[2]?.elementName as keyof typeof label
                    ]
                  : masteringStore.RestorationData.supervisorDetails?.[2]?.elementName}
                :{masteringStore.RestorationData.supervisorDetails?.[2]?.elementValue}
              </td>
              <td  className='border-top-0'>
              <br /> <br /> <br /> <br /><br /><br />
                {label[
                  masteringStore.RestorationData.supervisorDetails?.[3]?.elementName as keyof typeof label
                ] !== undefined
                  ? label[
                      masteringStore.RestorationData.supervisorDetails?.[3]?.elementName as keyof typeof label
                    ]
                  : masteringStore.RestorationData.supervisorDetails?.[3]?.elementName}
                :{dateConvertHandler(masteringStore.RestorationData.supervisorDetails?.[3]?.elementValue)}
              </td>
            </tr>
          </table>
               {isDualPDF ? 
              <div style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
            {/* eslint-disable-next-line */}
            <img 
              src={getImageSrc('bala')} 
              style={{ width: 65, height: 35, marginTop: 20 }} 
            />
          </div> : null}
        </div>
      </body>
    </html>
  );

  const getDynamicTableData = (ele: any, setterName: string) => {
    const temp: any = {};
    temp['headers'] = [];
    temp['body'] = [];
    let columnHeaders: string[] = [];
    let tempValue: any[] = [];
    if (ele?.elementValue?.includes('DynamicTable|')) {
      let stringData = ele?.elementValue?.split('DynamicTable|')?.[1]?.replaceAll(/\n/g,'');
      stringData = stringData?.split('_')?.join(' ');
      stringData = stringData.toString();
      //  stringData = stringData.replaceAll(/\\/g, '');
      try {
        tempValue =
          stringData !== undefined &&
          typeof stringData === 'string' &&
          JSON.parse(stringData) !== undefined
            ? JSON.parse(stringData)
            : [];
      } catch (err) {
        return console.error('JSON ERROR', err);
      }
   tempValue = tempValue?.map((element: { "Reel No": string }) => {
    const reelNo = element["Reel No"].toString();
    return {
        ...element,
        "Reel No": reelNo.includes('_') ? reelNo.replace(/\s/g, '_') : reelNo
    };
});
  tempValue = tempValue?.map(
        ({ 'Start Frame': _, 'End Frame': __, 'End Time Code': ___, 'Start Time Code': ____,'Time-code':_____, 'newColoumn': ______, ...rest }) => rest
    );
      columnHeaders = Object?.keys(tempValue?.[0] || []);
      columnHeaders = columnHeaders?.filter((data) => data !== ' uuid ');
    }
    if(ele?.elementValue === ''){
      ele?.options?.filter((e: any) => e.optionName !== 'Start Frame' && e.optionName !== 'End Frame').forEach((option:any) => {
        columnHeaders[option.optionIndex] = option.optionName?.replaceAll('_',' ')
      });
      if (!tempValue[0]) {
        tempValue[0] = {};
    }
      columnHeaders.forEach((value: string) => {
        tempValue[0][value] = '';
      });
      masteringStore.RestorationData.emptyTable = true;
    }
    temp['headers'] = columnHeaders;
    temp['body'] = tempValue;
    if (setterName === 'Image Restoration') {
      temp['headers'] = ['Reel no.', 'Time-code','Defects', '# of Frames Affected', 'Image restoration details', 'Tools used', 'Approved/ Not Approved/ Feedback',];
      temp.body = temp?.body?.map((item: any) => {
        return {
          ...item,
          'Reel no.': item['Reel No'],
          '# of Frames Affected': item['No of Frames Affected'] || item['Number of Frames Affected'],
          'Time-code': item['Time code'], 
          'Approved/ Not Approved/ Feedback': item['Approved or Not Approved']
        };
      }).map((item: any) => {
        return temp['headers'].reduce((acc: any, key: any) => {
          acc[key] = item[key]?.toString() || '';
          return acc;
        }, {});
      });
      masteringStore.RestorationData.dynDataImageResto = temp;
      // setDynDataImageResto(temp);
    } else if (setterName === 'NFHM QC Restoration Supervisor Feedback') {
       temp['headers'] = ['Reel no.', 'Time-code','Defects', 'Image restoration details/Issues', '# of Frames Affected', 'Rectified by Vendor (Yes/ No)', 'Approved/ Not Approved',];
      temp.body = temp?.body?.map((item: any) => {
        return {
          ...item,
          'Reel no.': item['Reel No'],
          'Time-code': item['Time code'],
          '# of Frames Affected': item['No of Frames Affected'] || item['Number of Frames Affected'],
        };
      }).map((item: any) => {
        return temp['headers'].reduce((acc: any, key: any) => {
          acc[key] = item[key]?.toString() || '';
          return acc;
        }, {});
      });
      masteringStore.RestorationData.dynDataSupervisor = temp;
      // setDynDataSupervisor(temp);
    }
  };

  useEffect(() => {
    const tempTableData: any = {};

    tempTableData[0] = [];
    tempTableData[1] = [];
    tempTableData[2] = [];
    tempTableData[4] = [];

    const tempSupervisor: metadataType[] = [];

    metadata?.forEach((m: metadataType) => {
      if (pictureVendor.includes(m.elementName)) {
        tempTableData[0][pictureVendor.indexOf(m.elementName)] = m;
      }
      if (aSummaryResto.includes(m.elementName)) {
        tempTableData[1][aSummaryResto.indexOf(m.elementName)] = m;
      }
      if (
        m.elementType === 'DynamicTable' &&
        m.elementName?.includes('Image Restoration')
      ) {
        getDynamicTableData(m, 'Image Restoration');
      }
      if (
        m.elementType === 'TextArea' &&
        m.elementName === 'NFHM QC Supervisor Comments'
      ) {
        tempTableData[2].push(m);
      }

      if (
        m.elementType === 'DynamicTable' &&
        m.elementName?.includes('NFHM QC Restoration Supervisor Feedback')
      ) {
        getDynamicTableData(
          m,
          'NFHM QC Restoration Supervisor Feedback',
        );
      }
      if (supervisorIndicesResto.includes(m.elementName)) {
        tempSupervisor[supervisorIndicesResto.indexOf(m.elementName)] = m;
      }
    });

    const filmElement = metadata.find(
      (element) => element.elementName === 'Film Element',
    );
    const Asset_Id = metadata.find(
      (element) => element.elementName === 'Asset ID',
    );
    tempTableData[1] = tempTableData[1].map((element: any) => {
      if (element.elementName === 'Asset ID') {
        return {
          ...element,
          elementValue:
            filmElement?.elementValue + ', ' + (Asset_Id?.elementValue || ''),
        };
      }
      return element;
    });
    masteringStore.RestorationData.localMetaData = tempTableData;
    masteringStore.RestorationData.supervisorDetails = tempSupervisor;
    // setLocalMetaData(tempTableData);
    // setSupervisorDetails(tempSupervisor);
     // eslint-disable-next-line
  }, [metadata]);

  const html = ReactDOMServer.renderToStaticMarkup(element);
  return (
    <Document>
      <Page style={{ padding: '18px' }}>
        <Html>{html}</Html>
      </Page>
    </Document>
  );
};

export default observer(NFAIRestorationReport);
